import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { HydrationGate } from '@/components/HydrationGate';
import { router } from '@/router';

export function App(): JSX.Element {
  return (
    <HydrationGate>
      <RouterProvider router={router} />
      <Toaster richColors position="top-right" />
    </HydrationGate>
  );
}
